import React, { useEffect, useState } from 'react';
import FetchData from '../fetch-api/Apifetch';
import { BASE_URL, LIST_REPORT, ADMIN_UPDATE_PASSWORD, UPDATE_USER_PASSWORD } from '../utils/ApiRoute';
import { handleProImageError } from '../utils/Function';
import Swal from 'sweetalert2';
import i18n from '../utils/i18n';
import { useTranslation } from 'react-i18next';
import CommonModal from './CommonModal';
import { Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { EncryptData } from '../utils/Constants';
import { SelectedEmpContext, SelectedDeviceContext } from '../context/GlobalContext';

const Header = ({ toggleSidebar, search, setSearch, filters }) => {
  const [user, setuser] = useState(JSON.parse(localStorage.getItem('token')));
  const [crypto] = useState(JSON.parse(localStorage.getItem('crypto_key')));
  const initialLang = localStorage.getItem('lang') || 'en'; // Default to 'en' if not set
  const [lang, setLang] = useState(initialLang);
  const { t, i18n } = useTranslation();
  const [updateModal, setupdateModal] = useState(false)
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [UserId, setUserId] = useState(user.emp_id);
  const [filter, setfilter] = useState(user.emp_id);
  // const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [matchError, setMatchError] = useState("");
  const [isValid, setIsValid] = useState(false);

  const passwordPattern = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;
  const [Password, setPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [oldPasswordError, setOldPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const handleUpdate = async () => {
    if (!oldPassword) {
      setOldPasswordError(t("Current_Password_Required"));
      return;
    }
    const payload = {
      old_password: oldPassword,
      new_password: Password
    }
    await FetchData(UPDATE_USER_PASSWORD, "POST", JSON.stringify(payload), true, false)
      .then((res) => {
        if (res.status) {
          toast.success(t("Password_Updated_Success"));
        }
        clearpassword()
      })
      .catch((error) => {
        if (error.message) {
          toast.error(error.message === "Failed to fetch" ? t("Something_went_wrong") : error.message,);
        }
      });
    setupdateModal(false)
  }

  // Effect to handle future changes to the language
  useEffect(() => {
    document.documentElement.setAttribute('lang', lang); // Optionally, set the 'lang' attribute
    document.body.style.direction = lang === 'ar' ? 'rtl' : 'ltr'; // Apply the direction to the body
  }, [lang]);

  const toggleLanguage = () => {
    const newLang = lang === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang); // Toggle between 'en' and 'ar'
    setLang(newLang); // Update the language state
    localStorage.setItem('lang', newLang); // Store the new language in sessionStorage
    window.location.reload()
  };

  // const handleLogout = async () => {
  //   sessionStorage.clear()
  //   window.location.href = '/login';
  // }

  const handleLogout = async () => {
    const lang = localStorage.getItem("lang");
    const userTypeStr = localStorage.getItem("userType");
    let isAdmin = false;

    if (userTypeStr) {
      isAdmin = (parseInt(userTypeStr) === 1);
    } else {
      const tokenStr = localStorage.getItem('token');
      if (tokenStr) {
        try {
          const tokenData = JSON.parse(tokenStr);
          isAdmin = (tokenData?.type === 1);
        } catch (e) {
          // Ignore parse error
        }
      }
    }

    localStorage.clear(); // Clear everything

    if (lang) {
      localStorage.setItem("lang", lang); // Restore lang back
    }
    if (userTypeStr) {
      localStorage.setItem("userType", userTypeStr); // Restore user type
    }

    window.location.href = isAdmin ? "/admin-login" : "/login";
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    validatePassword(newPassword, confirmPassword);
  };

  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setConfirmPassword(newConfirmPassword);
    validatePassword(Password, newConfirmPassword);
  };

  // ✅ Check password validity and matching
  const validatePassword = (pass, confirmPass) => {
    if (!passwordPattern.test(pass)) {
      setPasswordError("Password must be at least 6 characters, include letters, numbers, and special characters.");
    } else {
      setPasswordError("");
    }

    if (pass !== confirmPass && confirmPass.length > 0) {
      setMatchError("Passwords do not match.");
    } else {
      setMatchError("");
    }

    setIsValid(passwordPattern.test(pass) && pass === confirmPass);
  };

  const clearpassword = () => {
    setConfirmPassword('')
    setPassword('')
    setMatchError('')
    setIsValid(false)
    setPasswordError('')
  }

  return (
    <header className="app-header">
      <style>
        {`
    .swal2-popup {
      font-size: 1rem; /* Adjust font size of the popup */
    }

    .custom-confirm-button,
    .custom-cancel-button {
      border: none;
      border-radius: 0.375rem; /* Adjust border radius */
      font-size: 1rem; /* Font size of the button text */
      font-weight: bold; /* Font weight */
      padding: 0.75rem 1.25rem; /* Button padding */
      margin: 0.25rem; /* Space between buttons */
      cursor: pointer; /* Pointer cursor */
    }

    .custom-confirm-button {
      background-color: #433EBE; /* Custom color for "Yes" button */
      color: #fff; /* Text color */
    }

    .custom-confirm-button:hover {
      background-color: #433EBE; /* Darker shade for hover effect */
    }

    .custom-cancel-button {
      background-color: #6c757d; /* Custom color for "No" button */
      color: #fff; /* Text color */
    }

    .custom-cancel-button:hover {
      background-color: #5a6268; /* Darker shade for hover effect */
    }

    .swal2-styled.swal2-confirm {
      background-color: #433EBE !important; /* Ensure color is applied */
    }

    .swal2-styled.swal2-cancel {
      background-color: #6c757d !important; /* Ensure color is applied */
    }
  `}
      </style>
      <nav className="main-header" aria-label="Global">
        <div className="main-header-container !px-[2rem]">
          <div className="header-content-left">
            {/* Start::header-element */}
            <div className="header-element">
              <div className="horizontal-logo d-none">
                <a href="#" className="header-logo">
                  <img
                    src='./public/assets'
                    alt="logo"
                    className="desktop-logo"
                  />
                  <img
                    src="/assets/images/brand-logos/applogo.png"
                    alt="logo"
                    className="toggle-logo"
                    width={50}
                    height={50}
                  />
                  <img
                    src="/assets/images/brand-logos/desktop-dark.png"
                    alt="logo"
                    className="desktop-dark"
                  />
                  <img
                    src="/assets/images/brand-logos/toggle-dark.png"
                    alt="logo"
                    className="toggle-dark"
                  />
                  <img
                    src="/assets/images/brand-logos/desktop-white.png"
                    alt="logo"
                    className="desktop-white"
                  />
                </a>
              </div>
            </div>

            {/* End::header-element */}
            <div className="header-element !items-center">
              {/* Start::header-link */}
              <a
                aria-label="Hide Sidebar"
                className="sidemenu-toggle animated-arrow header-link hor-toggle horizontal-navtoggle inline-flex items-center"
                href="javascript:void(0);"
              >
                <i className="header-icon fe fe-align-left"
                  // onClick={()=>{handleIconClick()}}  
                  onClick={toggleSidebar}
                />
              </a>
              <div className="d-none main-header-center hidden lg:block">
                <input
                  className="form-control placeholder:!text-headerprimecolor placeholder:opacity-70 placeholder:font-thin placeholder:text-sm"
                  placeholder={t('SearchForAnything')}
                  type="search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <button className="btn">
                  <i className="ri ri-search-2-line hidden md:block opacity-[0.5]" />
                </button>
              </div>
              {/* End::header-link */}
            </div>
          </div>

          <div className="header-content-right align-items-center gap-3">
            <Modal show={updateModal} onHide={() => { setupdateModal(false); clearpassword() }} className="modelfilter mode" size='mdsm' centered>
              <Modal.Header closeButton>
                <span className="fontsubtitle font-weight-bold text-dark1 mb-0 ml-4 w-100 d-flex">
                  {t('Update')} {t('Password')}
                </span>
              </Modal.Header>

              <Modal.Body>
                <div className="modal-body">
                  <div>
                    <div className=" col-md-12 my-1">
                      <label>{t("Enter_Current_Password")}</label>
                      <div className="position-relative">
                        <input
                          type={showOldPassword ? "text" : "password"}
                          value={oldPassword}
                          onChange={(e) => {
                            setOldPasswordError("")
                            setOldPassword(e.target.value)
                          }}
                          className="form-control mb-2"
                          style={{ paddingRight: '35px' }}
                        />
                        <i 
                          className={`ti ${showOldPassword ? 'ti-eye-off' : 'ti-eye'} position-absolute`} 
                          style={{ right: '10px', top: '10px', cursor: 'pointer', color: '#6c757d', fontSize: '1.1rem' }}
                          onClick={() => setShowOldPassword(!showOldPassword)}
                        ></i>
                      </div>
                      {oldPasswordError && <p className="text-danger"><small>{oldPasswordError}</small></p>}

                      <label>{t("EnterPassword")}</label>
                      <div className="position-relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          value={Password}
                          onChange={handlePasswordChange}
                          className="form-control mb-2"
                          style={{ paddingRight: '35px' }}
                        />
                        <i 
                          className={`ti ${showPassword ? 'ti-eye-off' : 'ti-eye'} position-absolute`} 
                          style={{ right: '10px', top: '10px', cursor: 'pointer', color: '#6c757d', fontSize: '1.1rem' }}
                          onClick={() => setShowPassword(!showPassword)}
                        ></i>
                      </div>
                      {passwordError && <p className="text-danger"><small>{passwordError}</small></p>}

                      <label>{t("confirmpassword")}</label>
                      <div className="position-relative">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          value={confirmPassword}
                          onChange={handleConfirmPasswordChange}
                          className="form-control mb-2"
                          style={{ paddingRight: '35px' }}
                        />
                        <i 
                          className={`ti ${showConfirmPassword ? 'ti-eye-off' : 'ti-eye'} position-absolute`} 
                          style={{ right: '10px', top: '10px', cursor: 'pointer', color: '#6c757d', fontSize: '1.1rem' }}
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        ></i>
                      </div>
                      {matchError && <p className="text-danger"><small>{matchError}</small></p>}

                      <button className="text-center btn btn-primary my-2 mx-auto" disabled={!isValid}
                        onClick={() => handleUpdate()}>{t('Update')} {t('Password')}</button>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>


            <div className="header-element items-center mr-2">
              <select
                className="form-select form-select-sm cursor-pointer border-0 text-dark dark:text-light"
                onChange={toggleLanguage}
                value={lang}
              >
                <option value="en">English</option>
                <option value="ar">عربي</option>
              </select>
            </div>

            <a onClick={() => setIsConfirmation(true)} role='button'>
              <img
                src={BASE_URL + user?.emp_image}
                style={{ width: '35px', height: '35px', borderRadius: '50%' }}
                onError={handleProImageError}
                alt="User Profile"
              />
            </a>

            <span onClick={() => { user.type != 1 && setupdateModal(true) }}>

              <div className='d-flex column-gap-3'>
                <strong>
                  {t('welcome')}
                  {" "}
                  {user?.name}
                  {" "}
                </strong>
                {user.type != 1 &&
                  <img src="/images/icons/setting.svg" width="20px" height="20px" style={{ maxHeight: '20px', filter: 'invert(24%) sepia(89%) saturate(4681%) hue-rotate(241deg) brightness(81%) contrast(90%)' }} className='' />}
              </div>
            </span>

            <img className='d-none d-md-block d-lg-block'
              // src='/images/logos/Toptecno Logo-1.png' 
              src='/assets/images/brand-logos/applogo.png'
              // style={{ width: '95px', height: '56px' }} 
              style={{ width: '56px', height: '56px' }}
            />
          </div>
        </div>
      </nav>
      <CommonModal
        icon={"/images/icons/logout.svg"}
        title={t("Are_you_sure")}
        desc={`${t('logoutalert')}`}
        submitText={`${t('yeslogout')}`}
        submitAction={() => { handleLogout() }}
        setShowModal={() => setIsConfirmation(false)}
        showModal={isConfirmation}
      />
    </header>
  );
};

export default Header;
